// Adresse der Aussteller-Profilseite (#239). Die Seite liegt in der
// Stellen-App auf einer eigenen WordPress-Seite; aus der Messe-App fuehrt ein
// echter Verweis dorthin, keine Router-Navigation.
export const exhibitorProfilePath = (id) => `/aussteller/${encodeURIComponent(id)}/`
